import forge from 'node-forge';
import CryptoJS from 'crypto-js';
import {Crypt} from 'hybrid-crypto-js';

// To base 64 encode a String
function base64urlEncode(str) {
  return btoa(str);
}
// To base 64 decode a String
function base64urlDecode(str) {
  return atob(str);
}
// T0 Base 64 escape a String (removes a spaces a string)
function base64urlEscape(str) {
  return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}


// To assign java script properties to another object
function assignProperties(dest, source) {
  for (var attr in source) {
    if (source.hasOwnProperty(attr)) {
      dest[attr] = source[attr];
    }
  }
}

// Function to sign the input string based on private key using sha 256
function sign(input, key)
{
  var crypt = new Crypt({
    md: 'sha256', // Options: sha1, sha256, sha384, sha512, and md5
});
  var signature = crypt.signature(key, input);
  var json_string = JSON.parse(signature);
  return json_string["signature"];
}


// Function to jwt encode a payload using the given private key
function jwt_encode(payload, key , options)
{
  // Check key
if (!key) {
  throw new Error('Require key');
}

var algorithm = "RS256";

// header, typ is fixed value.
var header = { typ: 'JWT', alg: algorithm };
if (options && options.header) {
  assignProperties(header, options.header);
}
// create segments, all segments should be base64 string
var segments = [];

var headerContent = base64urlEncode(JSON.stringify(header));
// headerContent = headerContent.substring(0,(headerContent.length -2))
segments.push(headerContent);
segments.push(base64urlEncode(JSON.stringify(payload)));
segments.push(sign(segments.join('.'), key));
return segments.join('.');
}
function customDecode(tok) {
    const offset = 13;
    var customDecoded = tok.split(',').reverse().join(',');
    customDecoded = customDecoded.split(',').map(charCode => String.fromCharCode(charCode - offset)).join('');
    return customDecoded;
}
function getJsonWebToken(method, request, p12Buffer,merchantId, jwtMerchantKey) {
var claimSet = '';
  var date = new Date(Date.now()).toUTCString();
  let tokEncode = document.getElementById("tok-id");
  var tokVal = "";
  if(tokEncode) {
      let tokEncodeAttr = tokEncode.getAttribute("data-tok-id");
      if(tokEncodeAttr) {
          tokVal = customDecode(tokEncodeAttr);
      }
  }
  var keyPass = jwtMerchantKey ? jwtMerchantKey : tokVal;
  
  // console.log(toUTF8Array(p12Buffer));    
  // Getting the certificate
  p12Buffer = atob(decodeURIComponent(p12Buffer));
var p12Der = p12Buffer;
var p12Asn1 = forge.asn1.fromDer(p12Der);
  var certificate = forge.pkcs12.pkcs12FromAsn1(p12Asn1, false, keyPass);


// Getting the RSA private key
var keyBags;
var bag;

// get pkcs8 key bags
keyBags = certificate.getBags({ bagType: forge.pki.oids.pkcs8ShroudedKeyBag });
bag = keyBags[forge.pki.oids.pkcs8ShroudedKeyBag][0];

if(bag == null)
{
  // if pkcs 8 bag is null, get rsa key bags
  keyBags = certificate.getBags({ bagType: forge.pki.oids.keyBag });
  bag = keyBags[forge.pki.oids.keyBag][0]; 
}

var privateKey = bag.key;
var rsaPrivateKey = forge.pki.privateKeyToPem(privateKey);

// Getting the certificate in PEM
var certBags = certificate.getBags({ bagType: forge.pki.oids.certBag });
  var cert = certBags[forge.pki.oids.certBag][0];
var certificatePem = forge.pki.certificateToPem(cert.cert);
  var certDer = forge.pki.pemToDer(certificatePem);
  var pemCertificate = forge.util.encode64(certDer.data);
if (method.toLowerCase() === "get" || method.toLowerCase() === "delete") {
  claimSet = "{\"iat\":\"" + date + "\"}";
}
else if (method.toLowerCase() === "post" || method.toLowerCase() === "patch" || method.toLowerCase() === "put") {
      //var digest = generateDigest(request);
      var sha256digest = CryptoJS.SHA256(request);
      //var utfsha256digest = CryptoJS.enc.Utf8.parse(sha256digest);
      var digest = CryptoJS.enc.Base64.stringify(sha256digest);

  claimSet = "{\"digest\":\"" + digest + "\",\"digestAlgorithm\":\"SHA-256\",\"iat\":\"" + date + "\"}";
}

var x5CList = [pemCertificate];
var customHeader = {
  'header': {
    'v-c-merchant-id': merchantId,
    'x5c': x5CList
  }
};

var claimSetObj = JSON.parse(claimSet);
//Generating JWToken
  var jwtToken = jwt_encode(claimSetObj, rsaPrivateKey, customHeader);
  return jwtToken;
}

function computeHttpSignature(config, headerHash) {
var template = 'keyid="${keyid}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"',
    sig = template;

// compute sig here
var signingBase = '';
config.headers.forEach(function(h){
  if (signingBase !== '') { signingBase += '\n'; }
  signingBase += h.toLowerCase() + ": " + headerHash[h];
});

var hashf = (function() {
    switch (config.algorithm) {
      // case 'hmac-sha1': return CryptoJS.HmacSHA1;
      case 'SHA256withRSA': return CryptoJS.HmacSHA256;
      // case 'hmac-sha512': return CryptoJS.HmacSHA512;
      default : return CryptoJS.HmacSHA256;
    }
  }());

var words = CryptoJS.enc.Base64.parse(config.secretkey);
var reword = CryptoJS.enc.Base64.stringify(words)

var hash = hashf(signingBase, words);
var signatureOptions = {
      keyid : config.keyid,
      algorithm: config.algorithm,
      headers: config.headers,
      signature : CryptoJS.enc.Base64.stringify(hash)
    };

// build sig string here
Object.keys(signatureOptions).forEach(function(key) {
  var pattern = "${" + key + "}",
      value = (typeof signatureOptions[key] != 'string') ? signatureOptions[key].join(' ') : signatureOptions[key];
  sig = sig.replace(pattern, value);
});

return sig;
}

// Function to get the JWT Token which internally computes in authorization token format
function getJWTToken(requestUrl,httpMethod, requestData, merchantId,certContents, jwtMerchantKey) {
var token = getJsonWebToken(httpMethod,requestData,certContents,merchantId, jwtMerchantKey);
var hostName = extractHostname(requestUrl);
token = "Bearer " + token;
return {
      "authorization": token,
      "host": hostName,
     }   
}
//This is a function which tries to validate P12 Certificate before parsing 
// Validation is trying to parse certificate file using merchant Id
function validateP12Certficate(merchantId,p12Buffer,passphrase)
{
  try
  {
    var p12Asn1 = forge.asn1.fromDer(p12Buffer);
    var password = passphrase ? passphrase : merchantId;
    forge.pkcs12.pkcs12FromAsn1(p12Asn1, false, password);
    return true;
  }
  catch(err)
  {
     return false;
  }  
}

function getHttpSignature(requestUrl, httpMethod, requestData, merchantId, keyId, secretKey) { 

  var targetUrl = requestUrl.replace(new RegExp('^https?://[^/]+/'),'/'); // strip hostname
  var hostName = extractHostname(requestUrl);
  var sha256digest = CryptoJS.SHA256(requestData);
  //var utfsha256digest = CryptoJS.enc.Utf8.parse(sha256digest);
  var base64sha256 = CryptoJS.enc.Base64.stringify(sha256digest);
  var computedDigest = 'SHA-256=' + base64sha256;
  var headerHash;
  var config;
  var sig
  var httpMethodLowerCase = httpMethod.toLowerCase();
  var utcDate =  (new Date()).toUTCString(); 

  if (httpMethodLowerCase != 'get' && httpMethodLowerCase != 'delete') {
    headerHash = {
        host: hostName,
        'v-c-date': utcDate,
        'request-target': httpMethodLowerCase + ' ' + targetUrl,
        digest: computedDigest,
        "v-c-merchant-id": merchantId
    };

    config = {
        algorithm: 'HmacSHA256',
        keyid: keyId,
        secretkey: secretKey,
        headers: ['host', 'v-c-date', 'request-target', 'digest', 'v-c-merchant-id']
    };
    sig = computeHttpSignature(config, headerHash);

    return {
        "host": hostName,
        "signature": sig,
        "digest": computedDigest,
        "v-c-merchant-id": merchantId,
        "v-c-date" : utcDate
    }


  } else {
    headerHash = {
        host: hostName,
        'v-c-date': utcDate,
        'request-target': httpMethodLowerCase + ' ' + targetUrl,
        "v-c-merchant-id": merchantId
    };

    config = {
        algorithm: 'HmacSHA256',
        keyid: keyId,
        secretkey: secretKey,
        headers: ['host', 'v-c-date', 'request-target', 'v-c-merchant-id']
    };
    sig = computeHttpSignature(config, headerHash);

    return {
        "host": hostName,
        "signature": sig,
        "v-c-merchant-id": merchantId,
        "v-c-date" : utcDate
    }

  }
}

function extractHostname(url) {
  var hostname;

  //find & remove protocol (http, ftp, etc.) and get hostname
  if (url.indexOf("//") > -1) {
      hostname = url.split('/')[2];
  }
  else {
      hostname = url.split('/')[0];
  }

  //find & remove "?"
  hostname = hostname.split('?')[0];

  //find & remove port number
  //Port is required for lower environment
  //hostname = hostname.split(':')[0];

  return hostname;
}

export default base64urlEncode;
export {base64urlEncode,base64urlDecode,base64urlEscape,sign,jwt_encode,getJWTToken,getJsonWebToken,computeHttpSignature,validateP12Certficate,getHttpSignature,assignProperties,extractHostname};